import React, { useContext, useState } from "react";
import Experience from "./experience/Experience";
import Tabs from "./tabs/Tabs";
import classes from "./Work.module.css";
import { companyList } from "./workDetails";
import { ThemeContext } from "../../ThemeProvider";
import Reveal from "react-awesome-reveal";
import { keyframes } from "@emotion/react";

const customAnimation = keyframes`
  from {
    opacity: 0;
    transform: translateY(40px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Work = () => {
  const [toggleState, setToggleState] = useState(1);

  const { dark } = useContext(ThemeContext);

  const toggleHandler = (index) => {
    setToggleState(index);
  };

  return (
    <Reveal
      keyframes={customAnimation}
      triggerOnce="true"
      duration={1000}
      fraction={0.2}
    >
      <section className={classes.work} id="work">
        <div className={classes.work__container}>
          <div
            className={
              dark
                ? `${classes.work__title} ${classes.work__title__dark}`
                : classes.work__title
            }
          >
            <h1>
              <span
                className={
                  dark
                    ? `${classes.work__title__num} ${classes.work__title__num__dark}`
                    : classes.work__title__num
                }
              >
                02.
              </span>{" "}
              My previous Stints
            </h1>
            <div className={classes.work__line}></div>
          </div>

          <div className={classes.work_details}>
            <div className={classes.activeLine}></div>
            {/* left side */}

            <div
              className={
                dark
                  ? `${classes.left__side} ${classes.left__side__dark}`
                  : classes.left__side
              }
            >
              {companyList?.map((item, idx) => (
                <Tabs
                  toggleNum={idx + 1}
                  name={item.name}
                  key={item.name + idx}
                  toggleState={toggleState}
                  toggleHandler={toggleHandler}
                />
              ))}
            </div>

            {/* Right side */}

            <div
              className={
                dark
                  ? `${classes.right__side} ${classes.right__side__dark}`
                  : classes.right__side
              }
            >
              {companyList?.map((item, idx) => (
                <Experience
                  toggleNum={idx + 1}
                  toggleState={toggleState}
                  name={item.name}
                  period={item.period}
                  points={item.points}
                  designation={item.designation}
                  key={item.name + idx}
                />
              ))}
            </div>
          </div>
        </div>
      </section>
    </Reveal>
  );
};

export default Work;
